<app-card-consulta (update)="update.emit($event)" [titulo]="titulo" [idConsulta]='idConsulta'
        [tipoConsulta]="tipoConsulta" [codigoControle]="codigoControle" [status]="status" [msg]="statusMsg" [token]="token">

        <ng-container *ngIf="consulta">
                <div *ngIf="consulta?.chassi">
                        <div class="chassi-decode">
                                <div *ngFor="let v of consulta?.chassi.split('')">
                                        {{v}}
                                </div>
                        </div>
                </div>

                <ul class="card-list-striped">
                        <li>
                                <span class="text-secondary">Chassi</span>
                                <span class="text-right">{{consulta?.chassi || "NAO INFORMADO"}}</span>
                        </li>
                        <li>
                                <span class="text-secondary">Localização da fábrica</span>
                                <span class="text-rightt">{{consulta?.localDaFabrica || "NAO INFORMADO"}}</span></li>
                        <li>
                                <span class="text-secondary">Veículo</span>
                                <span class="text-right">{{consulta?.veiculo || "NAO INFORMADO"}}</span>
                        </li>
                        <li>
                                <span class="text-secondary">Tração</span>
                                <span class="text-right">{{consulta?.tracao || "NAO INFORMADO"}}</span>
                        </li>
                        <li>
                                <span class="text-secondary">Marca</span>
                                <span class="text-right">{{consulta?.marca || "NAO INFORMADO"}}</span>
                        </li>
                        <li>
                                <span class="text-secondary">Tipo da Carroceria</span>
                                <span class="text-right">{{consulta?.tipoDaCarroceria || "NAO INFORMADO"}}</span>
                        </li>
                        <li>
                                <span class="text-secondary">Combustivel</span>
                                <span class="text-right">{{consulta?.combustivel || "NAO INFORMADO"}}</span>
                        </li>
                        <li>
                                <span class="text-secondary">País de origem</span>
                                <span class="text-right">{{consulta?.pais || "NAO INFORMADO"}}</span>
                        </li>
                        <li>
                                <span class="text-secondary">Fabricante</span>
                                <span class="text-right">{{consulta?.fabricante || "NAO INFORMADO"}}</span>
                        </li>
                        <li>
                                <span class="text-secondary">Modelo</span>
                                <span class="text-right">{{consulta?.modelo || "NAO INFORMADO"}}</span>
                        </li>
                        <li>
                                <span class="text-secondary">Versão</span>
                                <span class="text-right">{{consulta?.versao || "NAO INFORMADO"}}</span>
                        </li>
                        <li>
                                <span class="text-secondary">Motor</span>
                                <span class="text-right">{{consulta?.motor || "NAO INFORMADO"}}</span>
                        </li>
                        <li>
                                <span class="text-secondary">Ano Modelo</span>
                                <span class="text-right">{{consulta?.anoModelo || "NAO INFORMADO"}}</span>
                        </li>
                        <li>
                                <span class="text-secondary">Ano de Fabricação</span>
                                <span class="text-right">{{consulta?.anoFabricacao || "NAO INFORMADO"}}</span>
                        </li>
                        <li>
                                <span class="text-secondary">Portas</span>
                                <span class="text-right">{{consulta?.portas || "NAO INFORMADO"}}</span>
                        </li>
                        <li>
                                <span class="text-secondary">Código Fipe</span>
                                <span class="text-right">{{consulta?.codigoFipe || "NAO INFORMADO"}}</span>
                        </li>
                        <li *ngIf="tipoConsulta=='DECODIFICADOR_ESPECIAL'">
                                <span class="text-secondary">Código Molicar</span>
                                <span class="text-right">{{consulta?.codigoMolicar || "NAO INFORMADO"}}</span>
                        </li>
                        <li>
                                <span class="text-secondary">Região Geografica
                                </span><span class="text-right">{{consulta?.regiaoGeografica || "NAO INFORMADO"}}</span>
                        </li>
                        <li>
                                <span class="text-secondary">Verificação do Serial</span>
                                <span class="text-right">{{consulta?.verificacaoDoSerial || "NAO INFORMADO"}}</span>
                        </li>
                        <li>
                                <span class="text-secondary">Quantidade de eixos</span>
                                <span class="text-right">{{consulta?.quantidadeDeEixos || "NAO INFORMADO"}}</span>
                        </li>
                        <li>
                                <span class="text-secondary">Quantidade de Irregularidades</span>
                                <span class="text-right">{{consulta?.quantidadeDeIrregularidades || "NAO INFORMADO"}}</span>
                        </li>
                        <li>
                                <span class="text-secondary">Conclusão</span>
                                <span class="text-right">{{consulta?.conclusao || "NAO INFORMADO"}}</span>
                        </li>
                </ul>
        </ng-container>

</app-card-consulta>
